import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import FluigService from "../../../../services/resource/fluigComprasService";
import { Loading } from "../../../../componentes/loading/loading";

export default function ResumoPorFilial({ dataInicial, dataFinal, filtrar, openModal }) {
  const service = new FluigService();
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [tamanho, settamanho] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    service
      .resumoPorFilial(dataInicial, dataFinal)
      .then((response) => {
        const data = response?.data ?? [];
        const labels = data.map((item) => item.filial || "—");
        const values = data.map((item) => item.totalSolicitacoes || 0);
        settamanho(data.length);

        setChartOptions({
          chart: {
            type: "donut",
            events: {
              dataPointSelection: (event, chartContext, config) => {
                const index = config.dataPointIndex;
                const label = labels[index];
                openModal(label, "filial");
              },
            },
          },
          labels,
          legend: {
            position: "right",
          },
          stroke: {
            show: false,
            width: 0
          },
          plotOptions: {
            pie: {
              donut: {
                size: "50%", // aumenta a espessura da rosca
              },
            },
          },
          colors: [
            "#3B82F6",
            "#F97316",
            "#22C55E",
            "#393b57ff",
            "#c52294ff",
            "#daf108ff",
          ],
        });

        setChartSeries(values);
      })
      .catch((err) => console.error("Erro ao buscar API:", err))
      .finally(() => setLoading(false));
  }, [filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Solicitações por Filial
      </h3>
      <label className="text-muted-foreground text-sm">
        Distribuição das solicitações entre as unidades da empresa.
      </label>
      <div className="h-64">
        {!loading && tamanho > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="donut"
            height="100%"
          />
        ) : !loading ? (
          "Não existem dados disponíveis para o intervalo selecionado."
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}